import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { useForm } from 'react-hook-form';
const URI = ApiEndpoint + 'configuration/';

const EditCity = ({ idCity, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [states, setStates] = useState(null);

  const [city, setCity] = useState({
    clave: '',
    descripcion: '',
    idestado: 0
  });
  const [selectedEstado, setSelectedEstado] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();
  const getStatesList = async () => {
    setStates(null);

    httpClient('GET', URI + 'states', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setStates(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getCitiy = async () => {
    setCity(null);

    httpClient('GET', URI + 'city/' + idCity, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setSelectedEstado(response.data.idestado);
          setValue('clave', response.data.clave);
          setValue('descripcion', response.data.descripcion);
          setValue('estado', response.data.idestado);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    console.log('idCity', idCity);
    if (idCity > 0) getCitiy();
    getStatesList();
  }, []);

  const onSubmit = data => {
    console.log(data);

    if (idCity > 0) {
      httpClient(
        'put',
        URI + 'city/' + idCity,
        {
          idmunicipio: idCity,
          clave: data.clave,
          descripcion: data.descripcion,
          idestado: data.estado,
          idusuario: 1
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'city',
        {
          clave: data.clave,
          descripcion: data.descripcion,
          idestado: data.estado,
          idusuario: 1
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };

  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Estado</Form.Label>
                <Form.Control
                  as="select"
                  aria-label="Default select"
                  name="idestado"
                  id="idestado"
                  {...register('estado', {
                    required: 'Campo Requerido'
                  })}
                  isInvalid={!!errors.estado}
                  onChange={e => {
                    setValue('estado', e.target.value, {
                      shouldValidate: true
                    });
                    setSelectedEstado(e.target.value);
                  }}
                  value={`${selectedEstado}`}
                  style={{ minWidth: '250px' }}
                >
                  <option key={'location_0'} value="">
                    Selecciona un estado
                  </option>
                  {!!states?.length &&
                    states.map(estado => (
                      <option key={estado.idestado} value={estado.idestado}>
                        {estado.descripcion}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.category?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Clave</Form.Label>
                <FormControl
                  {...register('clave', {
                    required: 'Clave es requerido',
                    minLength: {
                      value: 4,
                      message: 'La Clave debe tener al menos 4 caracteres'
                    },
                    maxLength: {
                      value: 4,
                      message: 'La Clave debe tener maximo 4 caracteres'
                    }
                  })}
                  type="text"
                  defaultValue={city?.clave}
                  isInvalid={!!errors.clave}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.clave?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Descripcion</Form.Label>
                <FormControl
                  {...register('descripcion', {
                    required: 'Descripcion es requerido',
                    minLength: {
                      value: 3,
                      message: 'Descripcion debe tener al menos 4 caracteres'
                    },
                    maxLength: {
                      value: 30,
                      message: 'Descripcion debe tener máximo 30 caracteres'
                    }
                  })}
                  type="text"
                  defaultValue={city?.descripcion}
                  isInvalid={!!errors.descripcion}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.descripcion?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button type="submit" color="primary" size="sm">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};
EditCity.propTypes = {
  idCity: PropTypes.number.isRequired,
  closeModal: PropTypes.func
};

export default EditCity;
